"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var utils_1 = require("./utils");
var EllipsisMiddleComponent = react_1["default"].forwardRef(function (props, ref) {
  var label = props.label,
    width = props.width,
    _a = props.type,
    type = _a === void 0 ? 'primary' : _a,
    _b = props.size,
    size = _b === void 0 ? 'normal' : _b,
    className = props.className,
    restProps = __rest(props, ["label", "width", "type", "size", "className"]);
  var frameRef = (0, react_1.useRef)(null);
  var _c = __read((0, react_1.useState)(label), 2),
    result = _c[0],
    setResult = _c[1];
  var _d = __read((0, react_1.useState)(false), 2),
    wrap = _d[0],
    setWrap = _d[1];
  var prevRef = (0, react_1.useRef)(label);
  (0, react_1.useEffect)(function () {
    prevRef.current = label;
  });
  if (label !== prevRef.current && result !== label) {
    setResult(label);
  }
  var cssClass = "odc-text-".concat(type, " odc-text-").concat(size);
  (0, react_1.useImperativeHandle)(ref, function () {
    var frameNode;
    return (frameNode = frameRef.current) === null || frameNode === void 0 ? void 0 : frameNode;
  });
  (0, react_1.useEffect)(function () {
    var node = frameRef.current;
    if (node) {
      // 创建一个临时的元素，用于获取该元素在不换行时的高度
      var tmp = (0, utils_1.getDiv)({
        text: label,
        className: (0, classnames_1["default"])('ellipsis', cssClass)
      });
      var height = (0, utils_1.getHeight)(tmp);
      var cssWidth = '';
      if (width) {
        cssWidth = typeof width === 'string' ? width : "".concat(width, "px");
      } else {
        var parentNode = node.parentElement;
        cssWidth = (0, utils_1.getStyle)(parentNode, 'width') || "".concat(node.offsetWidth, "px");
      }
      // 设置元素宽度并移除强制不换行样式，再次获取高度
      tmp.style.width = cssWidth;
      tmp.classList.remove('ellipsis');
      var newHeight = (0, utils_1.getHeight)(tmp);
      if (height !== newHeight) {
        var cssText = "width: calc(".concat(cssWidth, " / 2 - 8px);");
        var left = (0, utils_1.getFirstLine)(node, 'left', cssClass, cssText);
        var right = (0, utils_1.getFirstLine)(node, 'right', cssClass, cssText);
        setResult("".concat(left, " ... ").concat(right));
        setWrap(true);
      }
      tmp.remove();
    }
  }, [frameRef, cssClass, width, label]);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-ellipsis-middle', cssClass),
    supportAllEvents: true,
    ref: frameRef
  }, EllipsisMiddleComponent), {
    title: wrap ? label : null,
    w: width
  }), result);
});
EllipsisMiddleComponent.displayName = 'EllipsisMiddle';
(0, spaui_utils_1.setComponentMark)(EllipsisMiddleComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(EllipsisMiddleComponent);